import type { AppCopy } from '../catalogs';

export const elAppCopy = {
  welcomeHeading: 'Πώς μπορώ να σας βοηθήσω σήμερα;',
  thinking: 'Σκέψη',
  scrollToBottom: 'Κάντε κύλιση προς τα κάτω',
  reasoning: 'Συλλογισμός',
  reasoningInProgress: 'σε εξέλιξη',
  citationPages: 'Σελίδες {first}–{last}',
  citationTitle: 'Απόσπασμα πηγής',
  citationLoading: 'Φόρτωση πηγής…',
  citationUnavailable: 'Το παρατιθέμενο κείμενο δεν είναι διαθέσιμο ή δεν έχετε πλέον πρόσβαση.',
  citationOpen: 'Άνοιγμα πηγής',
  citationCopied: 'Η παραπομπή αντιγράφηκε',
  copy: 'Αντιγραφή',
  more: 'Περισσότερα',
  tryAgain: 'Προσπαθήστε ξανά',
  answerTruncated: 'Η απάντηση έφτασε το όριο μήκους και διακόπηκε.',
  continueAnswer: 'Συνεχίστε την απάντηση',
  exportMarkdown: 'Εξαγωγή ως Markdown',
  edit: 'Επεξεργασία',
  cancel: 'Ακύρωση',
  update: 'Ενημέρωση',
  previous: 'Προηγούμενο',
  next: 'Επόμενο',
  messagePlaceholder: 'Στείλτε μήνυμα…',
  projectHomePlaceholder: 'Νέα συνομιλία: {project}',
  sharedChatEveryone: 'Όλοι στην {company} μπορούν να διαβάσουν αυτή τη συνομιλία',
  sharedChatOnePerson: '1 άτομο μπορεί να διαβάσει αυτή τη συνομιλία',
  sharedChatPeople: '{count} άτομα μπορούν να διαβάσουν αυτή τη συνομιλία',
  forkedChatPlaceholder: 'Συνεχίστε με τις δικές σας συνδέσεις…',
  newAnswer: 'Νέα απάντηση',
  messageInput: 'Εισαγωγή μηνύματος',
  sendMessage: 'Αποστολή μηνύματος',
  stopGenerating: 'Σταματήστε να δημιουργείτε',
  addAttachment: 'Προσθήκη συνημμένου',
  removeFile: 'Κατάργηση αρχείου',
  attachmentPreview: 'Προεπισκόπηση συνημμένου',
  imageAttachmentPreview: 'Προεπισκόπηση συνημμένου εικόνας',
  image: 'Εικόνα',
  openLink: 'ανοιχτός σύνδεσμος',
  document: 'Έγγραφο',
  file: 'Αρχείο',
  attachment: 'προσκόλληση',
  uploadFailed: 'η μεταφόρτωση απέτυχε',
  uploading: 'ανέβασμα',
  toolIncomplete: 'Ημιτελές',
  toolActivity: 'Δραστηριότητα',
  activityThinking: 'Σκέψη…',
  activityWriting: 'Γράφει…',
  activityWaiting: 'Αναμονή για την έγκρισή σας',
  activityStopped: 'Διακόπηκε',
  activityCouldNotFinish: 'Δεν ήταν δυνατή η ολοκλήρωση',
  activitySources: 'πηγές',
  activityShowThinking: 'Εμφάνιση σκέψης',
  activityOpen: 'Άνοιγμα δραστηριότητας',
  activitySteps: 'Βήματα',
  activitySourcesTab: 'Πηγές',
  activityUnavailable: 'Αυτή η δραστηριότητα δεν είναι διαθέσιμη.',
  activityInput: 'Είσοδος',
  activityOutput: 'Έξοδος',
  activityNoSources: 'Η απάντηση δεν παραπέμπει σε πηγές.',
  activityApprovedByReply: 'Εγκρίθηκε από την απάντησή σας',

  toolRunning: 'Σε εξέλιξη',
  toolComplete: 'Ολοκληρώθηκε',
  toolNeedsApproval: 'Απαιτείται έγκριση',
  toolInput: 'Είσοδος',
  toolCall: 'κλήση εργαλείου',
  toolCalls: 'κλήσεις εργαλείων',
  openMenu: 'Άνοιγμα μενού',
  closeMenu: 'Κλείσιμο μενού',
  close: 'Κλείσιμο',
  showInTextField: 'Εμφάνιση στο πεδίο κειμένου',
  settings: 'Ρυθμίσεις',
  appearance: 'Εμφάνιση',
  themeLight: 'Φωτεινό',
  themeDark: 'Σκούρο',
  themeSystem: 'Συστήματος',
  themeChoiceHelp:
    'Ισχύει σε όλες τις συσκευές σας. Η επιλογή «Συστήματος» ακολουθεί τη φωτεινή ή σκούρα λειτουργία κάθε συσκευής.',
  themeSaveFailed:
    'Δεν ήταν δυνατή η αποθήκευση της εμφάνισης, οπότε παραμένει αμετάβλητη. Προσπαθήστε ξανά.',
  toolUsed: 'Χρησιμοποιημένο εργαλείο',
  toolCancelled: 'Ακυρωμένο εργαλείο',
  toolResult: 'Αποτέλεσμα:',
  toolError: 'Σφάλμα:',
  toolCancelledReason: 'Ακυρωμένη αιτία:',
  approvalAllow: 'Να επιτρέπεται',
  approvalAlwaysAllow: 'Πάντα να επιτρέπεται',
  approvalDeny: 'Απόρριψη',
  approvalAlwaysDeny: 'Πάντα απόρριψη',
  approvalConfirm: 'Επιβεβαίωση',
  approvalBack: 'Πίσω',
  approvalApprovedResult: 'Εγκρίθηκε από τον χρήστη',
  approvalDeniedResult: 'Ο χρήστης αρνήθηκε την εκτέλεση του εργαλείου',
  logout: 'Αποσυνδεθείτε',
  loginOrCreateAccount: 'Είσοδος / Δημιουργία λογαριασμού',
  newChat: 'Νέα συνομιλία',
  untitledChat: 'Συνομιλία χωρίς τίτλο',
  previousChats: 'Προηγούμενες συνομιλίες',
  openChat: 'Ανοίξτε τη συνομιλία {title}',
  moreActionsForChat: 'Περισσότερες ενέργειες για το {title}',
  chatActions: 'Ενέργειες συνομιλίας',
  closeChatActions: 'Κλείσιμο ενεργειών συνομιλίας',
  deleteChatQuestion: 'Διαγραφή συνομιλίας;',
  deleteChatDescription: 'Η συνομιλία "{title}" θα διαγραφεί οριστικά.',
  deleteChat: 'Διαγραφή συνομιλίας',
  keepChat: 'Διατήρηση συνομιλίας',
  delete: 'Διαγραφή',
  deleting: 'Διαγραφή…',
  chatDeleteFailed: 'Δεν ήταν δυνατή η διαγραφή της συνομιλίας. Προσπαθήστε ξανά.',
  settingsDescription: 'Προσαρμόστε τον τρόπο με τον οποίο λειτουργεί ο βοηθός για εσάς.',
  settingsDesktopDescription: 'Προσαρμόστε τον τρόπο με τον οποίο σας απαντά ο βοηθός.',
  personalization: 'Εξατομίκευση',
  personalizationDescription: 'Προσαρμόστε τις οδηγίες που ακολουθεί ο βοηθός σε κάθε απάντηση.',
  languageAndRegion: 'Γλώσσα και περιοχή',
  languageAndRegionDescription: 'Επιλέξτε γλώσσα και ζώνη ώρας.',
  memories: 'Αναμνήσεις',
  memoriesDescription: 'Προβάλετε, επεξεργαστείτε ή διαγράψτε όσα θυμάται ο βοηθός για εσάς.',
  account: 'Λογαριασμός',
  accountDescription: 'Διαχειριστείτε τον λογαριασμό και οριστική διαγραφή των δεδομένων σας.',
  backToSettings: 'Επιστροφή στις ρυθμίσεις',
  closeSettings: 'Κλείστε τις ρυθμίσεις',
  settingsCategories: 'Κατηγορίες ρυθμίσεων',
  yourSettings: 'Οι ρυθμίσεις σας',
  dataAndAccount: 'Δεδομένα και λογαριασμός',
  viewAndManageMemories: 'Δείτε και διαχειριστείτε τι θυμάται ο βοηθός',
  loginToUseMemories: 'Συνδεθείτε για να χρησιμοποιήσετε αναμνήσεις',
  manageOrDeleteAccount: 'Διαχειριστείτε ή διαγράψτε τον λογαριασμό',
  unsavedChanges: 'Έχετε μη αποθηκευμένες αλλαγές',
  unsavedCloseDescription: 'Το κλείσιμο των ρυθμίσεων θα απορρίψει τις αλλαγές σε αυτήν τη σελίδα.',
  unsavedBackDescription: 'Η επιστροφή θα απορρίψει τις αλλαγές σε αυτήν τη σελίδα.',
  continueEditing: 'Συνεχίστε την επεξεργασία',
  discardChanges: 'Απόρριψη αλλαγών',
  saveChanges: 'Αποθήκευση αλλαγών',
  localSettingsNote:
    'Αποθηκεύτηκε σε αυτό το πρόγραμμα περιήγησης. Συνδεθείτε για αποθήκευση στον λογαριασμό σας.',
  personality: 'Προσωπικότητα',
  personalityHelp: 'Προσαρμοσμένες οδηγίες που ακολουθεί ο βοηθός σε κάθε απάντηση',
  personalityPlaceholder:
    'Για παράδειγμα: Να είστε συνοπτικοί και συγκεκριμένοι. Ζω στο Γκέτεμποργκ και μου αρέσει το χορτοφαγικό φαγητό.',
  timezone: 'Ζώνη ώρας',
  searchTimezone: 'Αναζήτηση ζωνών ώρας…',
  automaticBrowser: 'Αυτόματο (πρόγραμμα περιήγησης)',
  saved: 'Αποθηκεύτηκε {date}',
  addMemory: 'Προσθήκη ανάμνησης',
  newMemory: 'Νέα ανάμνηση',
  memoryPlaceholder: 'Για παράδειγμα: Προτιμώ σύντομες, συγκεκριμένες απαντήσεις.',
  editMemory: 'Επεξεργασία ανάμνησης',
  saveMemory: 'Αποθήκευση ανάμνησης',
  deleteMemory: 'Διαγραφή ανάμνησης',
  memorySaveFailed: 'Δεν ήταν δυνατή η αποθήκευση της μνήμης. Προσπαθήστε ξανά.',
  memoryLimitReached:
    'Μπορείτε να αποθηκεύσετε έως 50 αναμνήσεις. Διαγράψτε μία πριν προσθέσετε άλλη.',
  memoryInvalid:
    'Οι αναμνήσεις δεν μπορούν να περιέχουν συνδέσμους. Αφαιρέστε τον σύνδεσμο και προσπαθήστε ξανά.',
  memoryDeleteFailed: 'Δεν ήταν δυνατή η διαγραφή της μνήμης. Προσπαθήστε ξανά.',
  memoryLoadFailed: 'Δεν ήταν δυνατή η φόρτωση των αναμνήσεων.',
  loadingMemories: 'Φόρτωση αναμνήσεων…',
  emptyMemories:
    'Ο βοηθός αποθηκεύει αναμνήσεις για εσάς ενώ μιλάτε — τι σας αρέσει, πού ζείτε και τι κάνετε. Μπορείτε να τα δείτε, να τα επεξεργαστείτε και να τα διαγράψετε εδώ.',
  deleteAccountHelp:
    'Διαγράψτε οριστικά τον λογαριασμό και όλες τις σχετικές συνομιλίες, μνήμες και ρυθμίσεις.',
  deleteAccount: 'Διαγραφή λογαριασμού',
  deleteAccountQuestion: 'Να διαγραφεί οριστικά ο λογαριασμός;',
  deleteAccountDescription:
    'Όλες οι συνομιλίες, τα μηνύματα, οι μνήμες, οι ρυθμίσεις και τα διαπιστευτήρια σύνδεσης θα διαγραφούν. Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
  deleteAccountConfirm: 'Ναι, διαγράψτε τον λογαριασμό μου',
  accountDeleteFailed:
    'Δεν ήταν δυνατή η διαγραφή του λογαριασμού. Δεν καταργήθηκε τίποτα — δοκιμάστε ξανά.',
  logoutEverywhereTitle: 'Όλες οι συσκευές',
  logoutEverywhereHelp:
    'Αποσυνδεθείτε από όλες τις συσκευές και τα προγράμματα περιήγησης όπου είναι ανοιχτός ο λογαριασμός σας, μαζί και από αυτή.',
  logoutEverywhere: 'Αποσύνδεση παντού',
  logoutEverywhereQuestion: 'Αποσύνδεση από όλες τις συσκευές;',
  logoutEverywhereDescription:
    'Θα χρειαστεί να συνδεθείτε ξανά σε όλες τις συσκευές και τα προγράμματα περιήγησης, μαζί και σε αυτή. Οι συνομιλίες και οι ρυθμίσεις σας παραμένουν ως έχουν.',
  loggingOut: 'Αποσύνδεση…',
  logoutEverywhereFailed:
    'Δεν ήταν δυνατή η επιβεβαίωση ότι αποσυνδεθήκατε παντού. Δοκιμάστε ξανά ή ελέγξτε σε άλλη συσκευή αν είστε ακόμα συνδεδεμένοι.',
  settingsSaveFailed: 'Δεν ήταν δυνατή η αποθήκευση των ρυθμίσεων. Προσπαθήστε ξανά.',
  customInstructions: 'Προσαρμοσμένες οδηγίες',
  notSet: 'Δεν έχει οριστεί',
  automaticLanguage: 'Αυτόματη γλώσσα',
  automaticTimezone: 'αυτόματη ζώνη ώρας',
  appLanguage: 'Γλώσσα εφαρμογής',
  appLanguageHelp:
    'Ελέγχει ολόκληρη τη διεπαφή της εφαρμογής και τις ημερομηνίες. Οι απαντήσεις του βοηθού συνεχίζουν να ακολουθούν τη γλώσσα στην οποία γράφετε.',
  automaticBrowserLanguage: 'Αυτόματο (γλώσσα προγράμματος περιήγησης)',
  previousLanguageChoice: 'Προηγούμενη επιλογή: {language} ({locale})',
  previousLanguageChoiceCode: 'Προηγούμενη επιλογή ({locale})',
  canvasCopyLink: 'Αντιγραφή συνδέσμου',
  canvasLinkCopied: 'Ο σύνδεσμος αντιγράφηκε',
  actionUpdatedWithEdits: 'Ενημερώθηκε με τις αλλαγές σας',
  activityStepsDone: 'one:βήμα ολοκληρώθηκε|other:βήματα ολοκληρώθηκαν',
  activityResultsCount: 'one:αποτέλεσμα|other:αποτελέσματα',
  canvasCopyLinkFailed: 'Δεν ήταν δυνατή η αντιγραφή του συνδέσμου',
  canvasOpenInAgent: 'Άνοιγμα στην εφαρμογή {agent}',
  canvasExpand: 'Ανάπτυξη',
  canvasExitFullView: 'Έξοδος από πλήρη προβολή',
  webSourceUnread:
    'Συνδέεται σε αυτή την απάντηση. Η Poneva δεν διάβασε αυτή τη σελίδα, οπότε δεν υπάρχει κάτι να εμφανιστεί εδώ.',
  webSourceOpenOriginal: 'Άνοιγμα πρωτοτύπου',
  toolProgressSettings: 'Αλλαγή των ρυθμίσεών σας…',
  toolProgressAgent: 'Δημιουργία του agent…',
  toolProgressConnections: 'Αναζήτηση επιλογών σύνδεσης…',
  toolProgressResult: 'Προετοιμασία του αποτελέσματός σας…',
  toolProgressClarification: 'Προετοιμασία διευκρίνισης…',
  toolProgressKnowledge: 'Προετοιμασία προτεινόμενης ενημέρωσης γνώσης…',
  toolProgressQuestion: 'Προετοιμασία ερώτησης για εσάς…',
  toolProgressSkill: 'Διαμόρφωση του Skill σας…',
  toolErrorSettings: 'Οι ρυθμίσεις σας δεν άλλαξαν.',
  toolErrorAgent: 'Δεν ήταν δυνατή η δημιουργία του agent.',
  toolErrorConnections: 'Δεν ήταν δυνατή η φόρτωση των επιλογών σύνδεσης.',
  toolErrorResult: 'Το αποτέλεσμα δεν αποθηκεύτηκε.',
  toolErrorClarification: 'Δεν ήταν δυνατή η προετοιμασία της διευκρίνισης.',
  toolErrorKnowledge: 'Δεν ήταν δυνατή η προετοιμασία της προτεινόμενης ενημέρωσης γνώσης.',
  toolErrorQuestion: 'Δεν ήταν δυνατή η προετοιμασία της ερώτησης.',
  toolErrorSkill: 'Δεν ήταν δυνατή η αποθήκευση του προσχεδίου του Skill.',
  toolErrorOpenSettings: 'Άνοιγμα Ρυθμίσεων',
  toolErrorOpenAgents: 'Άνοιγμα Agents',
  toolErrorOpenConnections: 'Άνοιγμα Συνδέσεων',
  toolStepIncomplete: 'Αυτό το βήμα δεν ολοκληρώθηκε.',
  toolEarlierAttemptsFailed:
    'one:προηγούμενη προσπάθεια δεν ολοκληρώθηκε|other:προηγούμενες προσπάθειες δεν ολοκληρώθηκαν',
} satisfies AppCopy;
